import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import RightNavbar from "./RightNavbar";
import AuthContext from "../store/AuthContext";
import { smLogo } from "../iconsImports";
import { maleAvatar, femaleAvatar, userAvt } from "../iconsImports";
import {
  account_nav,
  Admin_nav,
  Ad_nav,
  Api_nav,
  Asm_nav,
  customer_nav,
  nav,
  Md_nav,
  Zsm_nav,
  customer_nav2,
} from "../_nav";
import NavItemComponent from "./NavItemComponent";
import NavItemSubmenu from "./NavItemSubmenu";
import { setTitleFunc } from "../utils/HeaderTitleUtil";
import MenuIcon from "@mui/icons-material/Menu";
import { Avatar, Button, Grid, IconButton, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import RightNavBarMob from "./RightNavBarMob";
import Notifications from "./Notifications";
import {
  getHoverInActive,
  secondaryColor,
  whiteColor,
} from "../theme/setThemeColor";
import LogoComponent from "./LogoComponent";
import { useEffect } from "react";
import { useContext } from "react";
import ComputerIcon from "@mui/icons-material/Computer";
import AdminBadgeComponent from "./AdminBadgeComponent";
import Mount from "./Mount";
import TransactionsData from "./rendringPage/TransactionsData";
import WalletCard from "./WalletCard";
import axios from "axios";
// import ThemeSelector from "../modals/ThemeSelector";
const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const WebAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: "999",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const WebDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// let filterCNav = customer_nav_super;
export default function SideNav(props, { data }) {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  const setIp = user.setIp;
  const ip = user.ip;
  const theame = authCtx.theame;
  // console.log("ip is",ip);

  // const [authUser, setAuthUser] = React.useState(user);
  // const access = authCtx.token;
  const [activeIndex, setActiveIndex] = React.useState({
    index: 0,
    subIndex: -1,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const location = useLocation();
  const title = setTitleFunc(location.pathname, location.state);
  const [open, setOpen] = React.useState(false);

  // defining alias here
  const { window: SideWindow } = props;
  const container =
    SideWindow !== undefined ? () => SideWindow().document.body : undefined;

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isBig, setIsBig] = React.useState(
    window.innerWidth < 900 ? false : true
  );
  // ##############################
  // not used for now don't delete
  // ##############################
  // eslint-disable-next-line no-unused-vars
  const [filterCNav, setFilterCNav] = React.useState(customer_nav);
  const changeApply = () => {
    if (window.innerWidth < 900) setIsBig(false);
    else if (window.innerWidth > 900) setIsBig(true);
  };

  // ####################################
  // useEffect to apply window size event
  // ####################################
  useEffect(() => {
    window.addEventListener("resize", changeApply);
    return () => {
      window.removeEventListener("resize", changeApply);
    };
  }, []);
  // const [ip, setIp] = React.useState("");
  const [isPhone, setIsPhone] = React.useState(false);

  useEffect(() => {
    // Fetch the IP address
    const fetchIp = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIp(response.data.ip);
      } catch (error) {
        console.error("Error fetching the IP address:", error);
      }
    };

    fetchIp();

    // Detect if the user is on a phone
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android|iPad|iPhone|iPod/.test(userAgent.toLowerCase())) {
      setIsPhone(true);
    }
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    authCtx.logout();
    setAnchorEl(null);
    navigate("/");
  };
  console.log("userdata of", user);
  const leftNav =
    user && user.role === "Admin"
      ? Admin_nav
      : user && user.role === "Asm"
      ? Asm_nav
      : user && user.role === "Zsm"
      ? Zsm_nav
      : user && user.role === "Ad"
      ? Ad_nav
      : user && user.role === "Md"
      ? Md_nav
      : user && user.role === "Api"
      ? Api_nav
      : user && user.role === "Acc"
      ? account_nav
      : user && (user.role === "Ret" || user.role === "Dd")
      ? user?.st === 0 ||
        user?.nepal_transfer === 0 ||
        user?.acst === 0 ||
        user?.username !== 7011256694
        ? (user?.layout === 2 ? customer_nav2 : customer_nav).map((item) => {
            // Filter logic
            if (!user.irctc && item.title === "IRCTC") return undefined;
            if (user?.username == 7011256694 && item.title === "Travel") {
              return undefined;
            }
            if (user?.nepal_transfer === 0 && item.title === "Nepal Transfer") {
              return undefined;
            }
            if (
              user?.dmt4 === 0 &&
              user?.st === 0 &&
              item.title === "Vendor Payments"
            ) {
              return undefined;
            }
            if (user?.aeps === 0 && item.title === "AEPS") {
              return undefined;
            }
            if (user?.stm === 0 && item.title === "Settlements") {
              return undefined;
            }
            if (user?.upi_transfer === 0 && item.title === "UPI Transfer") {
              return undefined;
            } else {
              return item;
            }
          })
        : user?.layout === 2
        ? customer_nav2
        : customer_nav
      : nav;

  const outletBoxStyle = {
    width: {
      lg:
        user?.role === "Admin"
          ? "100%"
          : user?.role === "Asm"
          ? "100%"
          : user?.role === "Zsm"
          ? "100%"
          : // : user?.role === "Api"
          // ? "100%"
          location.pathname !== "/customer/transactions" &&
            location.pathname !== "/api-user/transactions" &&
            location.pathname !== "/account/dashboard" &&
            location.pathname !== "/ad/transactions" &&
            location.pathname !== "/md/transactions" &&
            location.pathname !== "/ad/sale" &&
            location.pathname !== "/md/sale" &&
            location.pathname !== "/ad/purchase" &&
            location.pathname !== "/md/purchase"
          ? "100%"
          : "100%",
      xs: "100%",
    },
    justifyContent: "start",
    alignContent: "left",
    marginLeft:
      user?.role === "Ret" || user?.role === "Dd"
        ? { md: "1.4rem", sm: "0.5rem", xs: "0.5rem" }
        : { md: "1.3rem", sm: "0.5rem", xs: "0.5rem" },
    marginRight:
      user?.role === "Ret" || user?.role === "Dd"
        ? { md: "0.5rem", sm: "0.5rem", xs: "0.5rem" }
        : { md: "0.9rem", sm: "0.5rem", xs: "0.5rem" },
    marginTop: "1rem",
  };

  const drawer = (
    <div>
      <DrawerHeader sx={{ justifyContent: "space-between", pr: 1 }}>
        {(open || mobileOpen) && (
          <LogoComponent
            style={{
              padding: "4px",
              display: "block",
              margin: "0 auto",
              // backgroundColor: whiteColor(),
            }}
          />
        )}
        {!open && !mobileOpen && (
          <img
            src={smLogo}
            width="35px"
            alt="c_logo"
            style={{
              padding: "4px",
              display: "block",
              margin: "0 auto",
              // backgroundColor: whiteColor(),
            }}
          />
        )}
      </DrawerHeader>
      <Divider
      // sx={{
      //   backgroundColor: "#ffffff",
      // }}
      />
      <List
        sx={{
          height: { xs: "80vh", sm: "100vh" },
          overflowY: "scroll",
          // backgroundImage: theame,
          backgroundColor: "#4A90E2",
        }}
      >
        {leftNav.map((item, index) => {
          return item && item.submenus ? (
            <NavItemSubmenu
              item={item}
              open={open || mobileOpen}
              setOpen={setOpen}
              mobileOpen={mobileOpen}
              handleDrawerToggle={handleDrawerToggle}
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              key={index}
            />
          ) : (
            item && (
              <NavItemComponent
                item={item}
                open={open || mobileOpen}
                setOpen={setOpen}
                mobileOpen={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
                index={index}
                key={index}
              />
            )
          );
        })}
        {/* {open && (
          <Typography
            // onClick={handleLogout}
            sx={{ textAlign: "left", pl: 5, mt: 2, color: whiteColor() }}
          >
            <span
              style={{
                opacity: "0.9",
                fontSize: "14px",
                fontWeight: "600",
                marginRight: "10px",
              }}
            > */}
        {/* {user?.role === "Dd" ? (
                <Button
                  sx={{ color: "#012169" }}
                  startIcon={<LogoutIcon sx={{ color: "#5698ba" }} />}
                >
                  Sign Out
                </Button>
              ) : (
                <Button
                  sx={{ color: "#012169" }}
                  startIcon={<LogoutIcon sx={{ color: "#5698ba" }} />}
                >
                  Logout
                </Button>
              )} */}
        {/* </span>
          </Typography>
        )} */}
        {open && (
          <Typography
            sx={{ textAlign: "left", pl: 5, mt: 2, color: whiteColor() }}
          >
            <span
              style={{
                opacity: "0.9",
                fontSize: "14px",
                fontWeight: "600",
                marginRight: "5px",
              }}
            >
              VERSION:
            </span>
            <span style={{ fontSize: "13px" }}>
              {process.env.REACT_APP_VERSION}
            </span>
            <ComputerIcon sx={{ ml: 2, fontSize: "17px", opacity: "0.8" }} />
          </Typography>
        )}
      </List>
      <Divider />
    </div>
  );

  return (
    <Box sx={{ display: "flex", fontFamily: "Poppins" }}>
      <CssBaseline />
      <WebAppBar
        position="fixed"
        open={open}
        sx={{
          paddingRight: "0px !important",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            overflowX: "auto",
            pr: { xs: 0, md: 1 },
            gap: 1,
          }}
          className="nav"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: { xs: 0, sm: 5 },
                ...(open && { display: "none" }),
              }}
            ></IconButton>
            {user?.layout === 1 && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: { md: 2, sm: 0, xs: 0 }, display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <div
              className="col"
              onClick={() => navigate("/customer/services")}
              style={{ marginBottom: "-8px" }}
              // hidden={user?.layout === 1}
              hidden={true}
            >
              <div className="con">
                <div className="bar arrow-top-r"></div>
                <div className="bar arrow-middle-r"></div>
                <div className="bar arrow-bottom-r"></div>
              </div>
            </div>
            <Typography
              variant="h6"
              component="div"
              sx={{
                textAlign: "left",
                fontFamily: "Poppins",
                fontWeight: "bold",
                marginLeft: { md: 3, sm: 3 },
                fontSize: { md: "20px", sm: "15px", xs: "15px" },
              }}
            >
              {title}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flexWrap: "nowrap",
            }}
          >
            {user && user.role !== "Admin" && (
              <Box sx={{}}>
                <WalletCard />
              </Box>
            )}
            {user && user.role === "Admin" && <AdminBadgeComponent />}
            <Mount visible={user?.role !== "Admin"}>
              {" "}
              <Notifications />
            </Mount>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ color: "#000", mr: { xs: -2, sm: 0, md: 1 } }}
            />
            <Button
              sx={{
                borderRadius: "0px",
                p: 0,
                textAlign: "right",
              }}
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Tooltip title="MY Profile" placement="bottom">
                <Avatar
                  id="user_img"
                  alt={user.name}
                  src={
                    // !["0", "1"].includes(user.profile_image)?
                    // user.profile_image :
                    user.gender === "FEMALE" ? femaleAvatar : maleAvatar
                  }
                  sx={{ width: 35, height: 35 }}
                />
              </Tooltip>
              <Grid sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
                <Typography
                  component="span"
                  sx={{
                    padding: 1,
                    textTransform: "capitalize",
                  }}
                >
                  {user && user.name}
                </Typography>
              </Grid>
            </Button>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              keepMounted
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <div
                style={{
                  margin: 0,
                  paddingTop: "0rem",
                  width: "250px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <MenuItem
                  disableRipple
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "-8px",
                    "&:hover": { cursor: "default", background: "#fff" },
                  }}
                >
                  {/* {user && user.profile_image !== "0" ? (
                    <Avatar
                      id="user_img"
                      alt={user.name}
                      src={user && user.profile_image}
                      sx={{ width: 80, height: 80 }}
                    />
                  ) : (
                    <Avatar
                      alt="Remy Sharp"
                      src="../src/assets/maleAvatar.jpeg"
                    />
                  )} */}

                  <Avatar
                    id="user_img"
                    alt={user.name}
                    src={
                      // !["0", "1"].includes(user.profile_image)?
                      // user.profile_image :
                      user.gender === "FEMALE" ? femaleAvatar : maleAvatar
                    }
                    sx={{ width: 35, height: 35 }}
                  />

                  <span
                    style={{
                      fontWeight: "550",
                      fontSize: "0.9rem",
                      marginTop: "0.3rem",
                    }}
                  >
                    {user && user.name}
                  </span>

                  <span
                    onClick={() => {
                      if (user && user.role === "Admin") {
                        navigate("/admin/my-profile");
                      } else if (user && user.role === "Asm") {
                        navigate("/asm/my-profile");
                      } else if (user && user.role === "Zsm") {
                        navigate("/zsm/my-profile");
                      } else if (user && user.role === "Ad") {
                        navigate("/ad/my-profile");
                      } else if (user && user.role === "Md") {
                        navigate("/md/my-profile");
                      } else if (user && user.role === "Acc") {
                        navigate("/account/my-profile");
                      } else if (
                        user &&
                        (user.role === "Ret" || user.role === "Dd")
                      ) {
                        navigate("/customer/my-profile");
                      } else if (user && user.role === "Api") {
                        navigate("/api-user/my-profile");
                      } else {
                        navigate("/other/my-profile");
                      }
                      handleClose();
                    }}
                    style={{
                      border: "1px solid #3f3f3f",
                      borderRadius: "16px",
                      padding: "0.2rem 1rem",
                      fontSize: "0.9rem",
                      margin: "1rem 0",
                    }}
                    className="simple-hover"
                  >
                    Manage your Profile
                  </span>
                </MenuItem>

                <div className="profile-dropdown-divider-new"></div>
                <MenuItem
                  disableRipple
                  onClick={() => {
                    handleLogout();
                    navigate("/login");
                  }}
                  sx={{
                    width: "100%",
                    marginBottom: "-8px",
                    textAlign: "center",
                    py: 2,
                    display: "flex",
                    justifyContent: "center",
                    "&:hover": {
                      backgroundColor: getHoverInActive(),
                      color: "#fff",
                    },
                  }}
                >
                  Logout <LogoutIcon className="ms-2" fontSize="small" />
                </MenuItem>
              </div>
            </Menu>
          </div>
        </Toolbar>
      </WebAppBar>

      {/* mobile drawer */}
      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          position: "absolute",
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            background: "rgba(35, 25, 66, 0.8)",
            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(35, 25, 66, 0.3)",
          },
          zIndex: "1000",
        }}
      >
        {drawer}
      </Drawer>

      {/* web drawer the side one small one*/}
      {user?.layout ? (
        (user?.layout * 1 === 1 || user?.layout * 1 === 2) && (
          <>
            <WebDrawer
              variant="permanent"
              open={open}
              onMouseOver={handleDrawerOpen}
              onMouseLeave={handleDrawerClose}
              sx={{
                position: "absolute",
                zIndex: "1000",
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  background: "rgb(250, 250, 250)",
                  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(35, 25, 66, 0.3)",
                },
              }}
              className=""
            >
              {drawer}
            </WebDrawer>
          </>
        )
      ) : (
        <>
          <WebDrawer
            variant="permanent"
            open={open}
            onMouseOver={handleDrawerOpen}
            onMouseLeave={handleDrawerClose}
            sx={{
              position: "absolute",
              zIndex: "1000",
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
              },
            }}
            className=""
          >
            {drawer}
          </WebDrawer>
        </>
      )}

      <Box
        component="main"
        sx={{
          width: "100%",
          display: "block",
          margin: "0 auto",
          paddingLeft: user?.layout
            ? user.layout === 1 || user.layout === 2
              ? "58px"
              : "0px"
            : "58px",
        }}
        className="rm-pd-sm"
      >
        <DrawerHeader />
        {/* {
  user &&
  (user.role === "Ret" || user.role === "Dd") && location.pathname === "/customer/dashboard" && (
    <Box sx={{ mt: 3, ml: 2, mr: 2 }}>
      <TransactionsData />
    </Box>
  )
} */}

        {/* ############################ */}
        <div
          className={
            location?.pathname === "/customer/services"
              ? "grey-bg"
              : "outlet-bg"
          }
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box sx={outletBoxStyle}>
            <Outlet />
          </Box>
          {user?.role === "Admin"
            ? ""
            : user?.role === "Asm"
            ? ""
            : user?.role === "Zsm"
            ? ""
            : user?.role === "Acc"
            ? ""
            : // : user?.role === "Api"
              // ? ""
              location.pathname !== "/customer/transactions" &&
              location.pathname !== "/api-user/transactions" &&
              location.pathname !== "/ad/transactions" &&
              location.pathname !== "/md/transactions" &&
              location.pathname !== "/ad/sale" &&
              location.pathname !== "/md/sale" &&
              location.pathname !== "/ad/purchase" &&
              location.pathname !== "/md/purchase" && (
                <>{isBig ? <RightNavbar /> : <RightNavBarMob />}</>
              )}
        </div>
      </Box>
    </Box>
  );
}
